import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgError = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M16.0001 29.3337C8.63628 29.3337 2.66675 23.3641 2.66675 16.0003C2.66675 8.63653 8.63628 2.66699 16.0001 2.66699C23.3638 2.66699 29.3334 8.63653 29.3334 16.0003C29.3334 23.3641 23.3638 29.3337 16.0001 29.3337ZM16.0001 26.667C21.8911 26.667 26.6667 21.8914 26.6667 16.0003C26.6667 10.1093 21.8911 5.33366 16.0001 5.33366C10.109 5.33366 5.33341 10.1093 5.33341 16.0003C5.33341 21.8914 10.109 26.667 16.0001 26.667ZM14.6667 20.0003H17.3334V22.667H14.6667V20.0003ZM14.6667 9.33366H17.3334V17.3337H14.6667V9.33366Z",
		fill: "#D92D20"
	})
});
export default SvgError;
